import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import "tailwindcss/tailwind.css";
import { globalLocales } from '@fullcalendar/core';
import pt from '@fullcalendar/core/locales/pt';
import useFetchData from "../../../repo/get"; 
import FichaPesquisa from "components/hooks/CardPesquisar";
import listPlugin from "@fullcalendar/list";
globalLocales.push(pt);

export default function Calendar() {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const baseSelect = localStorage.getItem("baseSelected") || "";
  const cargoSelect = localStorage.getItem("cargo") || "";

  const { data, error } = useFetchData(`api/romaneios/getMinimalAll/aguardando/${baseSelect}`);

  useEffect(() => {
    if (data) {
      const mappedEvents = data.map((romaneio) => ({
        title: romaneio.cidade,
        start: romaneio.data.split("T")[0],
        color: "#5A85AA",
        description: romaneio.codigoUid,
        link: romaneio.codigoUid,
        entregador: romaneio.entregador,
      }));
  
      if (cargoSelect === "ENTREGADOR") {
        const nomeEntregador = localStorage.getItem("nome");
        setEvents(mappedEvents.filter(event => event.entregador === nomeEntregador));
      } else {
        setEvents(mappedEvents);
      }
    } else if (error) {
      console.error(error);
    }
  }, [data, error, cargoSelect]);
  

  const handleEventClick = (info) => {
    setSelectedEvent(null); 
    setTimeout(() => {
      setSelectedEvent(info.event);
    }, 0); 
  };

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white p-6">
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, listPlugin]}
        initialView="dayGridMonth"
        headerToolbar={{
          left: "prev,next",
          center: "title",
          right: "dayGridMonth,listWeek"
        }}
        events={events}
        dayMaxEvents={true}
        locale="pt-br"
        eventClick={handleEventClick}
        eventContent={(eventInfo) => (
          <div>
            <strong>{eventInfo.event.title}</strong>
            <div>{eventInfo.event.extendedProps.description}</div>
          </div>
        )}
      />

      {selectedEvent && (
        <FichaPesquisa ficha={selectedEvent.extendedProps.link} />
      )}
    </div>
  );
}
